// import jQuery from 'CommonScripts/jquery-1.10.2';
import overlayDialog from './overlayDialog';
require('../../common/shadowbox/shadowbox');

(function (document, $) {

    $(document).ready(function () {
         /* ShadowBox overwrite default options */
        Shadowbox.init({ animate: false });

        if (typeof Sitecore == "undefined") {
            $('a.modal').on('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                var addressValue = $(this).attr("href");

                if (event.target.classList.contains('is-iframe')) {
                    var shadowboxElem = document.getElementById('sb-container');
                    var htmlElem = document.querySelector('HTML');

                    Shadowbox.open({
                        player: 'iframe',
                        content: addressValue,
                        options: {
                            onOpen: function () {
                                if (event.target.classList.contains('is-fullscreen')) {
                                    htmlElem.style.overflow = 'hidden';
                                    shadowboxElem.classList.add('is-fullscreen');
                                }
                            },
                            onClose: function () {
                                htmlElem.style.overflow = '';
                                shadowboxElem.classList.remove('is-fullscreen');
                            }
                        }
                    });
                } else {
                    var div = $('<div>');

                    $(div).load(encodeURI(addressValue) + ' #blankcontent', function (html) {
                        overlayDialog.show(div.html());
                    });
                }
            });
        }

    });
})(document, jQuery);

